<template>
	<div class='eleadIcon'>4444</div>
</template>
<script setup lang='ts' name='eleadIcon'></script>
<style scoped lang='less'>
	.eleadIcon {
	}
</style>
